import { IController } from 'angular';
import { map } from 'lodash';
import { ManageUsersEditPermissionsModal } from './../manage-users-modals/edit-permissions/manage-users-edit-permissions-modal.service';
import { IManageUsersSharedState, IManageUsersUser } from './../manage-users.controller';

export class ManageUsersHeaderCtrl implements IController {
  static $inject: string[] = ['ManageUsersEditPermissionsModal', 'UserRolePermissionsForModelService', 'Rollbar'];

  // bindings
  sharedState: IManageUsersSharedState;
  getSelectedUsers;
  updateUsersDelegatedRole;

  constructor(private manageUsersEditPermissionsModal: ManageUsersEditPermissionsModal, private Rollbar) {}

  $onInit() {
    //
  }

  public showEditPermissionsModal(): void {
    const selectedUserIds = this.getSelectedUserIds();

    this.manageUsersEditPermissionsModal
      .show(selectedUserIds)
      .then(updatedUsers => {
        if (updatedUsers) {
          this.updateUsersDelegatedRole({
            ids: updatedUsers.ids,
            delegatedRole: updatedUsers.delegatedRole,
          });
        }
      })
      .catch(err => {
        this.Rollbar.error(`Unable to update user's delegated role: `, err);
      });
  }

  private getSelectedUserIds(): string[] {
    const selectedUsers: IManageUsersUser[] = this.getSelectedUsers();
    const selectedUserIds: string[] = map(selectedUsers, u => u._id);

    return selectedUserIds;
  }
}
